/** PDP copy: short blurb vs full description must not be mixed. */

type GroupCopyFields = {
  short_summary?: string | null;
  short_description?: string | null;
  marketing_description?: string | null;
  description?: string | null;
  full_specs?: { description?: string } | null;
};

function normalizeCopy(value: string | null | undefined): string {
  return String(value ?? '').replace(/\s+/g, ' ').trim();
}

/** group_id для PATCH /admin/catalog-content/by-group — всегда карточка витрины, не publicV2Slug. */
export function resolveAdminGroupContentSaveId(
  group: { group_id?: string | null },
  effectiveGroupId?: string | null,
): string {
  const id = String(effectiveGroupId || group.group_id || '').trim();
  if (!id) throw new Error('group_id required');
  return id;
}

export function resolveProductGroupFullCopy(group: GroupCopyFields): string {
  return normalizeCopy(group.description || group.full_specs?.description);
}

export function resolveProductGroupShortCopy(group: GroupCopyFields): string {
  const full = resolveProductGroupFullCopy(group);
  const candidates = [
    group.short_summary,
    group.short_description,
    group.marketing_description,
  ];
  for (const raw of candidates) {
    const text = normalizeCopy(raw);
    if (!text) continue;
    if (full && text === full) continue;
    return text;
  }
  return '';
}

/** Слияние текста с API без подмены полного кратким (устаревший ответ бэка). */
export function mergeProductGroupCopyFromApi(
  api: GroupCopyFields,
  previous?: GroupCopyFields | null,
): { short: string; full: string } {
  const short = resolveProductGroupShortCopy(api) || (previous ? resolveProductGroupShortCopy(previous) : '');
  let full = resolveProductGroupFullCopy(api) || (previous ? resolveProductGroupFullCopy(previous) : '');
  const prevFull = previous ? resolveProductGroupFullCopy(previous) : '';
  if (short && full === short && prevFull && prevFull !== short) {
    full = prevFull;
  }
  return { short, full };
}
